/* tslint:disable */

declare var Object: any;
export interface SFShiftDailyInterface {
  "id"?: number;
}

export class SFShiftDaily implements SFShiftDailyInterface {
  "id": number;
  constructor(data?: SFShiftDailyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFShiftDaily`.
   */
  public static getModelName() {
    return "SFShiftDaily";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFShiftDaily for dynamic purposes.
  **/
  public static factory(data: SFShiftDailyInterface): SFShiftDaily{
    return new SFShiftDaily(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFShiftDaily',
      plural: 'SFShiftDailies',
      path: 'SFShiftDailies',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFShiftDaily.ts